import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "@/store/store";
import { setIsVisibleModalDialog } from "@/store/ui/ui";

import { IModalDialogProps } from "@/shared/interfaces/patientPage";

import "./ModalDialog.scss";
import CloseCross from "@/shared/components/CloseCross/CloseCross";
import Button from "@/shared/components/Button/Button";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction='up' ref={ref} {...props} />;
});

export default function ModalDialog({
    title,
    message,
    onConfirm,
    onCansel,
}: IModalDialogProps) {
    const dispatch = useDispatch();
    const isVisibleModalDialog = useSelector(
        (state: RootState) => state.ui.isVisibleModalDialog,
    );

    const isLocalLoading = useSelector(
        (state: RootState) => state.ui.isLocalLoading,
    );

    const onClose = () => {
        if (!isLocalLoading) {
            dispatch(setIsVisibleModalDialog(false));
        }
    };

    return (
        <Dialog
            open={isVisibleModalDialog}
            slots={{ transition: Transition }}
            keepMounted
            onClose={onClose}
            aria-describedby='alert-dialog-slide-description'
            slotProps={{
                paper: {
                    sx: {
                        maxWidth: 460,
                        backgroundColor: "#FFFFFF",
                        borderRadius: "6px",
                        fontFamily: "'Nunito Sans', sans-serif",
                        padding: "32px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                    },
                },
            }}
        >
            <div className='modal_header_container'>
                <h4>{title}</h4>
                <CloseCross onClick={onClose} />
            </div>
            <p className='modal_paragraf'>{message}</p>
            <div className='modal_button_container'>
                <Button
                    text={"Відмінити"}
                    onClick={() => {
                        onClose();
                        onCansel && onCansel();
                    }}
                    variant='edit-small'
                />
                <Button
                    text={"Видалити"}
                    onClick={onConfirm}
                    variant='delete'
                    disabled={isLocalLoading}
                    isLoading={isLocalLoading}
                />
            </div>
        </Dialog>
    );
}
